import PropTypes from "prop-types";

const CreateProjectModalPropType = {
  isConfirming: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  disableConfirmBtn: PropTypes.bool,
  closeBtnTitle: PropTypes.string,
  onConfirm: PropTypes.func,
  formData: PropTypes.object};

export default CreateProjectModalPropType;
